import { render, staticRenderFns } from "./newTemplate.vue?vue&type=template&id=41a2d0fe&scoped=true&"
import script from "./newTemplate.vue?vue&type=script&lang=js&"
export * from "./newTemplate.vue?vue&type=script&lang=js&"
import style0 from "./newTemplate.vue?vue&type=style&index=0&id=41a2d0fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a2d0fe",
  null
  
)

export default component.exports